import { initUiLangSelector } from './lib/i18n';

initUiLangSelector();